export const SESSION_STORAGE_VAR = {
  authToken: 'HayGroup.User.authToken',
  userId: 'HayGroup.User.id',
  shadowClient: 'shadowClientName',
  lastRedirection: 'HayGroup.lastRedirection',
  shadowMode: 'Haygroup.user.shadowClient',
  language: 'KFONE_language',
  userDetails: 'kf1-userDetails',
  refreshToken: 'kf1-refreshToken',
  localAuthToken: 'kf1-localAuthToken',
  activeClient: '__kfone_active_client',
};
